export default class WishlistReview extends HTMLElement {
	constructor() {
		super();
		this.productId = null;
		this.data = null;
		this.globalRange = null;
		this.maxStars = 5;
	}

	async connectedCallback() {
		this.productId = this.dataset.productId;

		this.data = await this.fetchProductReviews();
		if (this.data) {
			this.render();
		}
	}

	async fetchProductReviews(offset = 0) {
		const response = await fetch(
			`https://api.bazaarvoice.com/data/reviews.json?apiversion=5.4&passkey=cad847lJKr7DKxfmLjtst0fp08OP4tSwgBBXRYt7xDheg&Filter=ProductId:${this.productId}&Sort=Rating:desc&Limit=5&Offset=${offset}&Include=Products&Stats=Reviews`,
		);
		if (!response.ok) {
			console.error('Something went wrong');
			return null;
		}
		return await response.json();
	}

	render() {
		if (this.data.Results.length === 0) {
			// no reviews
			this.hideStars();
		} else {
			this.initData();
			this.createStarsElement();
		}
	}

	initData() {
		// init data
		this.globalRange =
			this.data.Includes.Products[
				this.productId
			].ReviewStatistics.AverageOverallRating.toFixed(1);
	}

	createStarsElement() {
		const insideStars = this.querySelector('[data-full-stars]');
		const pourcentage = 100 - (this.globalRange / this.maxStars) * 100;
		insideStars.style.clipPath = `inset(0 ${pourcentage}% 0 0)`;
	}

	hideStars() {
		const elReviewStars = this.querySelector('[data-review-stars]');
		elReviewStars.style.visibility = 'hidden';
		this.style.display = 'none';
		this.setAttribute('data-stars-is-hide', 'true');
	}

	disconnectedCallback() {}
}
